import {
  add,
  findIndex,
  identity,
  ifElse,
  lensProp,
  map,
  mergeRight,
  propEq,
  set,
} from "ramda";
import { arrayMove as reorderArray } from "@dnd-kit/sortable";
import { mapIndexed, notBlank } from "../../../util/ext";

/**
 * Mapper for setting order value for list of content items, e.g. album tracks, audiobook chapters
 * See: https://docs.dndkit.com/presets/sortable
 */
const mapIndexToProp = (prop, mutateIndexFn = identity) =>
  mapIndexed((item, index) =>
    mergeRight(item, { [prop]: mutateIndexFn(index) }),
  );

// Props related to ordering
export const mapChildOrder = mapIndexToProp("childOrder"); // Album Tracks, Book Chapters
export const mapDisplayOrder = mapIndexToProp("displayOrder", add(1)); // Collections within Anthology
export const mapOrder = mapIndexToProp("order"); // CSP Project Languages
export const mapSequences = mapIndexToProp("sequence"); // Audiobook Chapters

export const setProp = (prop, val) => set(lensProp(prop), val);

export const update = (id, prop, val) =>
  map(ifElse(propEq("id", id), setProp(prop, val), identity));

export const findItem = (id, items) => findIndex(propEq("id", id), items);

export const reorderItems = ({ active, over, mapper }) => items => {
  const oldIndex = findItem(active.id, items);
  const newIndex = findItem(over.id, items);

  // Can pass mapper to update prop of item moved
  return notBlank(mapper)
    ? mapper(reorderArray(items, oldIndex, newIndex))
    : reorderArray(items, oldIndex, newIndex);
};
